import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "../../actions"
import Modal from "react-responsive-modal"
import submitData from "helpers/submitData"
import clone from "clone"
import ReactTable from "react-table"
import _ from "lodash"
import moment from "moment"
import settings from "settings"
import BuyerModal from "containers/entry/modals/buyer"
import { toast } from "react-toastify"

class DocumentModal extends Component {
	constructor(props) {
		super(props)
		this.state = {
			ready: false,
			documents: [],
			buyerModal: false,
			buyerData: [],
			columns: [
				{
					Header: "Document",
					accessor: "document",
					maxWidth: 200,
				},
				{
					Header: "Submitted Date",
					accessor: "date",
					maxWidth: 150,
				},
				{
					Header: "Submitted By",
					accessor: "submitted_by",
					maxWidth: 150,
				},
				{
					Header: "File",
					accessor: "file",
					maxWidth: 110,
				},
				{
					Header: "Accept",
					accessor: "accept",
					maxWidth: 100,
				},
				{
					Header: "Reject",
					accessor: "reject",
					maxWidth: 100,
				},
				{
					Header: "Approved Date",
					accessor: "approved_date",
				},
				{
					Header: "File Name",
					accessor: "filename",
				},
				{
					Header: "Reason (emailed to salesperson)",
					accessor: "reason",
				},
			],
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.data !== this.props.data) {
			let documents = clone(this.props.data.documents)
			console.log(this.props.data)
			_.forEach(documents, (v, k) => {
				documents[k].changed = false // changed is describing whether or not this document was changed.  So we don't send duplicate rejection reasons on submit even if they didn't change anything.
				//documents[k].fileName = ""
				//documents[k].reason = ""
				//documents[k].reasonDisabledStatus = true
				if (v.attachment) {
					let split = v.attachment.split("/")
					documents[k].fileName = _.last(split)
				}
			})
			this.setState({ documents }, () => {
				console.log(this.state)
			})
		}
		return null
	}

	clearFile = (d,k) => {
		d.sale_id = this.props.data.id
		submitData("clearDocument", d).then((data) => {
			let obj = {
				status: true,
				title: "Cleared",
				text: "Document has been cleared.",
			}
			this.props.getDocs()
			let state = clone(this.state)
			state.documents[k].fileName = ""
			state.documents[k].attachment = false
			state.documents[k].status = 'awaiting'
			this.setState(state)
			
		})
	}

	buildTable = () => {
		let rows = []
		_.forEach(this.state.documents, (v, k) => {
			if (v.type == "profile" && v.status == 'awaiting') {
				// Don't show the buyer profile row until they submit it.
				return
			}
			let type = ""
			let findType = _.find(this.props.payload.public.options.docs, { dbName: v.type })
			if (findType) {
				type = findType.name
			}

			let file = ""
			if (v.type == "profile") {
				file = (
					<span className="pointer blue" onClick={() => this.openBuyer()}>
						View Profile
					</span>
				)
			} else {
				if(!v.attachment) {
					// not submitted yet
					file = 'Not Submitted'
				}
				else {
					file = (
						<>
							<p>
								<a href={settings.s3 + v.attachment} target="_blank">
									View File
								</a>
							</p>
							<p className="documentModal__clearFile">
								<a onClick={() => this.clearFile(v, k)}>
									<i className="fas fa-times-circle"></i>Clear File
								</a>
							</p>
						</>
					)
				}
				
			}
			let acceptStatus = v.status == "accepted" ? true : false
			let rejectStatus = v.status == "rejected" ? true : false
			let accepted = (
				<input
					name={k}
					type="radio"
					value={1}
					checked={acceptStatus}
					onChange={() => {
						let state = clone(this.state)
						state.documents[k].approved_date = moment().unix()
						state.documents[k].changed = true
						state.documents[k].status = "accepted"
						state.documents[k].reasonDisabledStatus = true
						this.setState(state)
					}}
				/>
			)
			let rejected = (
				<input
					name={k}
					type="radio"
					value={0}
					checked={rejectStatus}
					onChange={() => {
						let state = clone(this.state)
						state.documents[k].approved_date = false
						state.documents[k].changed = true
						state.documents[k].status = "rejected"
						state.documents[k].reasonDisabledStatus = false
						this.setState(state)
					}}
				/>
			)
			let reason = (
				<textarea
					name={k}
					value={this.state.documents[k].reason}
					disabled={this.state.documents[k].reasonDisabledStatus}
					onChange={(v) => {
						let state = clone(this.state)
						state.documents[k].reason = v.target.value
						state.documents[k].changed = true
						this.setState(state)
					}}></textarea>
			)
			let filename = (
				<input
					type="text"
					name={k}
					value={this.state.documents[k].fileName}
					className="padded"
					onChange={(v) => {
						console.log(v)
						let state = clone(this.state)
						state.documents[k].fileName = v.target.value
						state.documents[k].changed = true
						this.setState(state)
					}}></input>
			)

			let date = v.uploaded_date ? moment.unix(v.uploaded_date).format("MM/DD/YY LT") : ""
			let approved_date = v.approved_date ? moment.unix(v.approved_date).format("MM/DD/YY LT") : ""
			let submitted_by
			if (v.uploaded_by) {
				let submitter = _.find(this.props.payload.public.salespeople, { id: v.uploaded_by })
				if (submitter) {
					submitted_by = `${submitter.first} ${submitter.last}`
				} else {
					// check if this is a admin user
					submitter = _.find(this.props.payload.users, { id: v.uploaded_by })
					if (submitter) {
						submitted_by = `${submitter.first} ${submitter.last}`
					}
				}
			}
			

			rows.push({
				document: type,
				approved_date,
				date,
				file,
				accept: accepted,
				reject: rejected,
				submitted_by,
				reason,
				filename
			})
		})

		return rows
	}

	openBuyer = () => {
		let v = clone(this.props.data)
		v.sale_id = v.id
		this.setState({buyerModal: true, buyerData: v})
	}

	handleSubmit = () => {
		let docs = _.cloneDeep(this.state.documents)
		// Remove properties that don't need to get to the server.
		docs = _.map(docs, function (o) {
			return _.omit(o, ["reasonDisabledStatus"])
		})
		let d = {
			docs,
			sale_id: this.props.data.id,
		}
		//console.log(d)
		//return
		submitData("manageDocuments", d).then(data => {
			let obj = {
				status: true,
				title: "Recorded",
				text: "Document(s) have been recorded.",
			}
			this.props.alert(obj)
			this.props.getPayload()
		})
	}

	notify = () => {
		this.setState({buyerData:[], buyerModal: false})
		toast.success('Updated Profile')
	}

	render() {
		const { open } = this.props
		let section = ''
		let coBuyer = ''
		let secLook = _.find(this.props.payload.public.sections, {id: this.props.data.section_id})
		if(secLook) {
			section = secLook.name
		}
		if(this.props.data.has_co) {
			coBuyer = ` | Co-buyer: ${this.props.data.co_first} ${this.props.data.co_last}`
		}
		let builder = _.find(this.props.payload.public.builders, {id: this.props.data.builder})
		let builderName = builder ? ` | ${builder.name}` : ''
		let sp = _.find(this.props.payload.public.salespeople, { id: this.props.data.salesperson })
		let salesperson = sp ? ` | ${sp.first} ${sp.last}` : ""
		return (
			<div>
				<Modal open={open} onClose={this.props.onClose} center classNames={{ modal: "documentModal" }}>
					<h3>
						Document Management: {this.props.data.address}
						{builderName}
						{salesperson}
					</h3>
					<div className="documentModal__info">
						<p>
							LBS: {this.props.data.lot}/{this.props.data.block}/{section} | Buyer:{" "}
							{this.props.data.primary_first} {this.props.data.primary_last}
							{coBuyer}
						</p>
					</div>
					<ReactTable
						loadingText=""
						data={this.buildTable()}
						columns={this.state.columns}
						defaultPageSize={5}
					/>
					<button type="button" className="btn big" onClick={this.handleSubmit}>
						Submit
					</button>
				</Modal>
				<Modal
					classNames={{ modal: "modalForm" }}
					open={this.state.buyerModal}
					onClose={() => this.setState({ buyerModal: false })}
					center>
					<BuyerModal data={this.state.buyerData} notify={this.notify} name="buyerModal" super={true} />
				</Modal>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			getPayload,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(DocumentModal)
